import { BeneficiaryTypes } from 'enrollment/features/AddYourBeneficiaries/services';

export const getTotalAllocation = (beneficiaries: BeneficiaryTypes[]) => {
  return beneficiaries.reduce((acc, beneficiary) => {
    return acc + parseFloat(beneficiary.allocation);
  }, 0);
};
